import React, { useEffect, useRef, useState } from "react";

const FiltroMultiple = ({
    label,
    field,
    options,
    filtrosTemp,
    setFiltrosTemp,
    filtros,
    setFiltros,
    mostrarFiltro,
    setMostrarFiltro,
    actualizarPrioridad,
    setPrioridadFiltros,
    transformValue = (v) => v,
}) => {

    const [search, setSearch] = useState("");

    const buttonRef = useRef(null);
    const filtroRef = useRef(null);

    const toggleFiltro = () => {
        const rect = buttonRef.current.getBoundingClientRect();

        setSearch("");

        const FiltroWidth = 260;   // ajusta según tu CSS
        const FiltroHeight = window.innerHeight < 700 ? 200 : 320;  // aproximado del modal

        let top = rect.bottom + 4;
        let left = rect.left;

        // 🔥 evitar que se salga por abajo
        if (top + FiltroHeight > window.innerHeight) {
            top = rect.top - FiltroHeight - 4;
        }

        // 🔥 evitar que se salga por la derecha
        if (left + FiltroWidth > window.innerWidth) {
            left = window.innerWidth - FiltroWidth - 10;
        }

        // 🔥 evitar valores negativos
        if (left < 10) left = 10;
        if (top < 10) top = 10;

        setMostrarFiltro(prev => {
            const nuevoEstado = {};
            Object.keys(prev).forEach(key => {
                nuevoEstado[key] = { ...prev[key], open: false };
            });

            nuevoEstado[field] = {
                open: !prev[field]?.open,
                top,
                left
            };

            return nuevoEstado;
        });
    };
    useEffect(() => {
        const handleClickOutside = (e) => {
            // si el filtro está abierto y el click NO fue dentro del filtro ni del botón
            if (
                mostrarFiltro[field]?.open &&
                filtroRef.current &&
                !filtroRef.current.contains(e.target) &&
                !buttonRef.current.contains(e.target)
            ) {
                cerrarFiltro();
            }
        };

        const handleScroll = () => {
            if (mostrarFiltro[field]?.open) {
                cerrarFiltro();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        // window.addEventListener("scroll", handleScroll, true);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            window.removeEventListener("scroll", handleScroll, true);
        };
    }, [mostrarFiltro[field]?.open]);

    const removerPrioridad = (filtro) => {
        setPrioridadFiltros((prev) => {
            const index = prev.indexOf(filtro);

            // si no existe, no hacer nada
            if (index === -1) return prev;

            // 🔥 cortar desde ese filtro hacia adelante
            const nuevasPrioridades = prev.slice(0, index);

            // 🔥 limpiar filtros en cascada (igual que actualizarPrioridad)
            setFiltrosTemp((prevTemp) => {
                const limpio = { ...prevTemp };

                Object.keys(limpio).forEach((key) => {
                    if (!nuevasPrioridades.includes(key)) {
                        limpio[key] = [];
                    }
                });

                return limpio;
            });

            setFiltros((prevFiltros) => {
                const limpio = { ...prevFiltros };

                Object.keys(limpio).forEach((key) => {
                    if (!nuevasPrioridades.includes(key)) {
                        limpio[key] = [];
                    }
                });

                return limpio;
            });

            return nuevasPrioridades;
        });
    };


    const cerrarFiltro = () => {
        setMostrarFiltro(prev => ({
            ...prev,
            [field]: { ...prev[field], open: false }
        }));
    };

    // const opcionesFiltradas = options.filter(opt =>
    //     (opt.label || "").toLowerCase().includes(search.toLowerCase())
    // );

    const parseDate = (value) => {
    const date = new Date(value);
    return isNaN(date.getTime()) ? null : date;
};

const opcionesFiltradas = [...options]
    .sort((a, b) => {
        const valA = a?.label ?? "";
        const valB = b?.label ?? "";

        // 🔥 1. Detectar fechas
        const dateA = parseDate(valA);
        const dateB = parseDate(valB);

        if (dateA && dateB) {
            return dateA - dateB; // orden por fecha
        }

        // 🔥 2. Detectar números
        const numA = Number(valA);
        const numB = Number(valB);

        const isNumA = !isNaN(numA);
        const isNumB = !isNaN(numB);

        if (isNumA && isNumB) {
            return numA - numB;
        }

        // 🔥 3. Texto (default)
        return String(valA).localeCompare(String(valB), "es", {
            numeric: true,
            sensitivity: "base"
        });
    })
    .filter(opt =>
        (opt.label || "")
            .toString()
            .toLowerCase()
            .includes(search.toLowerCase())
    );

    return (
        <div className="grupo-header-con-select">
            {label}

            <button
                ref={buttonRef}
                type="button"
                className="motivo-select"
                onClick={toggleFiltro}
            />

            {mostrarFiltro[field]?.open && (
                <div
                    ref={filtroRef}
                    className="filtro-multiple filtro-fixed"
                    style={{
                        top: mostrarFiltro[field].top,
                        left: mostrarFiltro[field].left
                    }}
                >
                    {/* 🔍 BUSCADOR */}
                    <div className="filtro-buscador">
                        <input
                            type="text"
                            placeholder="Buscar..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </div>

                    {/* OPCIONES */}
                    <div className="filtro-opciones scroll">
                        {opcionesFiltradas.map(opt => {
                            const value = transformValue(opt.value);

                            return (
                                <label key={opt.value} className="checkbox-opcion">
                                    <input
                                        type="checkbox"
                                        checked={(filtrosTemp[field] || []).includes(value)}
                                        onChange={() =>
                                            setFiltrosTemp(prev => {
                                                const current = prev[field] || [];

                                                return {
                                                    ...prev,
                                                    [field]: current.includes(value)
                                                        ? current.filter(v => v !== value)
                                                        : [...current, value]
                                                };
                                            })
                                        }
                                    />
                                    <span>{opt.label}</span>
                                </label>
                            );
                        })}

                        {opcionesFiltradas.length === 0 && (
                            <div className="sin-resultados">Sin resultados</div>
                        )}
                    </div>

                    <div className="filtro-acciones">
                        {(filtros[field]?.length > 0 || filtrosTemp[field]?.length > 0) && (
                            <button
                                className="btn-limpiar-filtro"
                                onClick={() => {
                                    // limpiar solo este filtro
                                    setFiltrosTemp(prev => ({
                                        ...prev,
                                        [field]: []
                                    }));

                                    setFiltros(prev => ({
                                        ...prev,
                                        [field]: []
                                    }));

                                    removerPrioridad(field); // 👈 CAMBIO CLAVE
                                    cerrarFiltro();
                                }}
                            >
                                Limpiar
                            </button>
                        )}

                        <button
                            className="btn-aplicar-filtro"
                            onClick={() => {
                                setFiltros(prev => ({
                                    ...prev,
                                    [field]: filtrosTemp[field]
                                }));

                                actualizarPrioridad(field);
                                cerrarFiltro();
                            }}
                        >
                            Aplicar ({filtrosTemp[field]?.length || 0})
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default FiltroMultiple;
